import React from 'react'
import { I18n } from '@front/volcanion'

import moment from 'moment'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const getEtaValue = (row) => {
  const eta_time = _.get(row, 'current_target.eta.time')
  if (!!eta_time) {
    return `${moment.utc(eta_time).diff(moment.utc(), 'minutes')} min`
  }
  if (!!_.get(row, 'assigned_transport.info') && _.get(row, 'assigned_transport.status') === 'started') {
    const src_datetime = _.get(row, 'assigned_transport.info.src_datetime')
    if (moment.utc(src_datetime).isBefore(moment.utc())) {
      return I18n.t('date.outdated')
    }
    return `${moment.utc(src_datetime).diff(moment.utc(), 'minutes')} min`
  }
  return undefined
}

const Eta = ({ row }) => {
  const etaValue = getEtaValue(row)

  return (
    <TableCell padding='none'>
      <TextCell fontSize={13} textAlign='center' value={!!etaValue ? etaValue : '-'} noWrap />
    </TableCell>
  )
}

export default React.memo(Eta)
